import { formatOfferItemsDates } from 'pages/candidateOffer/helpers';
import { Offer } from 'pages/candidateOffer/types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { EntityViewBlock } from 'shared/components';

import PeriodsScheduleList from './PeriodsScheduleList';
import ShiftsScheduleList from './ShiftsScheduleList';

interface ScheduleProps {
    offer: Offer;
    timeZone: string;
}

export default function Schedule({ offer, timeZone }: ScheduleProps) {
    const { t } = useTranslation([ 'dates', 'candidateOffers' ]);

    const {
        shifts,
        periods
    } = offer;

    const formattedItemsWithDates = useMemo(
        () => formatOfferItemsDates(shifts, periods, timeZone, t),
        [ shifts, timeZone, t, periods ]);

    return (
        <EntityViewBlock title={ t('candidateOffers:schedule') }>
            { shifts?.length ? <ShiftsScheduleList items={ formattedItemsWithDates } /> : null }
            { periods?.length ? <PeriodsScheduleList items={ formattedItemsWithDates } /> : null }
        </EntityViewBlock>
    );
}
